import axios     from "axios"
import { parseType } from "graphql"
import G from "glob"

let CURRENT_DOMAIN = process.env.VUE_APP_DOMAIN || "tzaustria"

const GENERICS = {
    it01: { title: "Italy",
        site_guest_user: "w-guest@tzaustria.at",
        site_guest_password: "Guest@Wuerth"
    },
    "dalcin-it": { title: "Dal-Cin Italy",
        site_guest_user: "w-guest@tzaustria.at",
        site_guest_password: "Guest@Wuerth"
    },
    sg01: { title: "Showroom Singapur"
    },
    vn01: { title: "Vietnam"
    },
    bauking: { title: "BAUKING", logo : "/img/bauking-logo.png", title_as_alt : true,
        site_guest_user: "w-guest@tzaustria.at",
        site_guest_password: "Guest@Wuerth"
    },
    tzabudhabi: { title: "TZ Abu Dhabi"
    },
    "tzsaigon-hm": { title: "TZ Sigon HM"
    },
    tzgulfaustria : { title: "TZ Gulf Austria"
    },
    tzinnsbruck: { title: "TZ Innsbruck",
        site_guest_user: "w-guest@tzaustria.at",
        site_guest_password: "Guest@Wuerth"
    },
    tzbregenzerwald: { title: "TZ Bregenzerwald",
        site_guest_user: "w-guest@tzaustria.at",
        site_guest_password: "Guest@Wuerth"
    },
    tzbruneck: { title: "TZ Bruneck",
        site_guest_user: "w-guest@tzaustria.at",
        site_guest_password: "Guest@Wuerth"
    },
    tzhohenems: { title: "TZ Hohenems",
        site_guest_user: "w-guest@tzaustria.at",
        site_guest_password: "Guest@Wuerth"
    },
    "tzwiensued-marz": { title: "TZ Wiensüd Marz",
        site_guest_user: "w-guest@tzaustria.at",
        site_guest_password: "Guest@Wuerth"
    },
    "tzkrems": { title: "TZ Krems",
        site_guest_user: "w-guest@tzaustria.at",
        site_guest_password: "Guest@Wuerth"
    },
    "tzodoerfer-seefelder": { title: "TZ Odoerfer-Seefelder",
        site_guest_user: "w-guest@tzaustria.at",
        site_guest_password: "Guest@Wuerth"
    },
    "tzhartberg": { title: "TZ Hartberg",
        site_guest_user: "w-guest@tzaustria.at",
        site_guest_password: "Guest@Wuerth"
    },
    "habisreutinger": { title: "Habisreutinger",
        site_guest_user: "w-guest@tzaustria.at",
        site_guest_password: "Guest@Wuerth"
    },
    "messner": { title: "Messner",
        site_guest_user: "w-guest@tzaustria.at",
        site_guest_password: "Guest@Wuerth"
    },
    "tzkoeln-wiehl": { title: "TZ Koeln-Wiehl", logo: "/img/cnc_tischler.png"
    , aboutUrl: "https://www.cnc-tischler.de/betrieb.html"
    , contactUrl: "https://www.cnc-tischler.de/kontakt.html"
    , infoUrl: "https://www.cnc-tischler.de/" 
    , site_guest_user: "w-guest@tzaustria.at"
    , site_guest_password: "Guest@Wuerth"
    },
    fries24: { title: "Fries24",
        site_guest_user: "w-guest@tzaustria.at",
        site_guest_password: "Guest@Wuerth"
    },
    "tzmanilanorth": { title: "TZ Manila North"
    }
}

GENERICS ["dal-cin-it"] = GENERICS ["dalcin-it"]

let domains = {
    dev: {
        base: {
            domain: ".dev.local",
            prefix: "",
            cssClass: "dev",
            port:   8081,
            schema: "http",
            skipLogout: true,
            showMiddleName: true
        },
        tzaustria: {
            subdomain: "tzaustria"
        },
        tzaustria: {
            subdomain: "wuerth"
        },
    },
    stage: {
        base: {
            domain: ".tzaustria.info",
            prefix: "stage-",
            cssClass: "stage",
            skipLogout: true,
            showMiddleName: true
        },
        tzaustria: {
            subdomain: "tzaustria"
        },
    },
    netix: {
        base: {
            domain: ".tzaustria.info",
            prefix: "netix-",
            cssClass: "stage",
            skipLogout: true,
            showMiddleName: true
        },
        tzaustria: {
            subdomain: "tzaustria",
            skipLogout: true,
            site_guest_user: "w-guest@tzaustria.at",
            site_guest_password: "Guest@Wuerth"
        },
    },
    test: {
        base: {
            domain: ".tzaustria.info",
            cssClass: "test",
            prefix: "test-",
            skipLogout: true,
            showMiddleName: true
        },
        tzaustria: {
            subdomain: "tzaustria",
            site_guest_user: "w-guest@tzaustria.at",
            site_guest_password: "Guest@Wuerth"
        },
    },
    live: {
        base: {
            domain: ".designbox.solutions",
            prefix: "",
            cssClass: "live",
            port:   443,
            schema: "https",
            skipLogout: true,
            showMiddleName: true,
            defaultLocale: "en",
            generic: false
        },
        tzaustria: {
            subdomain: "tzaustria",
            title: "Designbox",
            admin: true,
            site_guest_user: "w-guest@tzaustria.at",
            site_guest_password: "Guest@Wuerth"
        },
        wuerth: {
            subdomain: "wuerth",
            title: "Designbox Würth",
            admin: true
        },
        haefele: {
            subdomain: "haefele",
            title: "Designbox Häfele",
            admin: true,
            site_guest_user: "w-guest@tzaustria.at",
            site_guest_password: "Guest@Wuerth"
        },
        mayrhofer: {
            subdomain: "holz-mayrhofer",
            title: "Designbox Holz-Mayrhofer",
            showMiddleName: false,
            defaultLocale: "de",
            admin: true,
            site_guest_user: "w-guest@tzaustria.at",
            site_guest_password: "Guest@Wuerth"
        },
        fries24: {
            subdomain: "fries24",
            title: "Designbox Fries",
            defaultLocale: "de",
            admin: true
        },
        generic: {
            admin: true,
            generic: true
        }
    }
}

let is_dev    = (process.env.VUE_APP_SYSTEM === "dev")
let is_stage  = (process.env.VUE_APP_SYSTEM === "stage")
let is_test   = (process.env.VUE_APP_SYSTEM === "test")
let is_netix  = (process.env.VUE_APP_SYSTEM === "netix")
let site_config = Object.assign({}, domains.live.base, domains.live [CURRENT_DOMAIN])
if (is_dev) {
    // we are in development mode
    site_config = Object.assign (
        site_config, domains.dev.base, domains.dev [CURRENT_DOMAIN] || {})
}
if (is_stage) {
    // we are in development mode
    site_config = Object.assign (
        site_config, domains.stage.base, domains.stage [CURRENT_DOMAIN] || {})
}
if (is_netix) {
    // we are in development mode
    site_config = Object.assign (
        site_config, domains.netix.base, domains.netix [CURRENT_DOMAIN] || {})
}
if (is_test) {
    // we are in test mode
    site_config = Object.assign (
        site_config, domains.test.base, domains.test [CURRENT_DOMAIN] || {})
}
if (CURRENT_DOMAIN == "generic") {
    const sd_parts = window.location.hostname.split (".", 1) [0].split ("-")
    let prefix
    if      (is_dev)    { prefix = "dev"   }
    else if (is_stage)  { prefix = "stage" }
    else if (is_test)   { prefix = "test"  }
    else if (is_netix)  { prefix = "netix" }
    if ((sd_parts.length > 1) && (sd_parts [0] == prefix)) {
        site_config.prefix    = sd_parts.shift () + "-"
    } else {
        site_config.prefix    = ""
    }
    site_config.subdomain = sd_parts.join ("-")
    console.log ("Config before merge", site_config.subdomain, site_config, GENERICS [site_config.subdomain])
    site_config = Object.assign (
        site_config, GENERICS [site_config.subdomain] || {})
    console.log ("Config after merge", site_config)
    }
site_config.base_url = site_config.schema + "://"
                     + site_config.prefix
                     + site_config.subdomain
                     + site_config.domain
                     + ":" + site_config.port
                     + "/"
site_config.poral_url = site_config.schema + "://"
                     + site_config.prefix
                     + "portal"
                     + site_config.domain
                     + ":" + site_config.port
                     + "/"
axios.defaults.baseURL = site_config.poral_url
if (is_dev || is_test || is_stage || is_netix) {
    console.log ("is_dev", is_dev, "is_test", is_test, "is_stage", is_stage, "is_netix", is_netix)
    console.log ("Site Config", site_config)
}
export default site_config
